

import { CheckboxVisibility, DefaultButton, DetailsList, Dropdown, IColumn, IContextualMenuItem, IDetailsRowProps, Label, Persona, PersonaInitialsColor, PersonaPresence, PersonaSize, PrimaryButton, SearchBox, Stack, TextField } from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import Paging from '../../control/paging'
import useToken from './login/useToken';
import * as Api from '../../api/src'
import { _renderRow } from '../../control/function/detailList'
import { API } from '@sentry/core';
import { LeftMenuContext } from '../../context/leftMenu.context';
import globalData from '../../common/globalData';
import { ToastAppType } from '../../common/constant/enum/toastAppType';
import { ToastAppMsgContext } from '../../context/toastApp.Context';
import moment from 'moment';
import { commonfn } from '../../common/commonfn';
import { useHistory } from 'react-router-dom';
import '../../css/components/userprofile.scss'
const UserApi = new Api.UserApi();
const UserProfile = () => {
    const { userTokenInfo } = useToken();
    const { t } = useTranslation();
    const { setSelectedMenuItem } = React.useContext(LeftMenuContext);
    const [idShowFrom, setIsShowFrom] = React.useState<boolean>(false);
    const [listWarringForOverdue, setListWarringForOverdue] = React.useState<any[]>([]);
    const [listLanguage, setListLanguage] = React.useState<any[]>([
        { key: "en", text: t('English') },
    ]);
    const [nameErrorMessage, SetNameErrorMessage] = React.useState('');
    const [detail, SetDetail] = React.useState<Api.UserResponse>({});
    const { setToastData } = React.useContext(ToastAppMsgContext);
    let routerHistory = useHistory();
    React.useEffect(() => {
        setSelectedMenuItem("");
        getData()
    }, [userTokenInfo]);
    const getData = () => {
        if (!userTokenInfo) return;
        UserApi.apiUserIdGet(userTokenInfo["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]).then((res) => {
            SetDetail(res.data.Data || {})
            setIsShowFrom(true);
        });
    }

    const save = () => {
        if (!userTokenInfo) return;
        UserApi.apiUserEditUserPost({ Id: parseInt((detail.Id || 0).toString()), FullName: detail.FullName, PhoneNumber: detail.PhoneNumber }).then((res) => {
            if (!res || res.status != 200) return;
            setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
        });
    }
    return (
        <>
            {idShowFrom && (
                <>
                    <div className={"page-header"}><Label>{t("UserProfile")}</Label></div>
                    <div className="page-content userprofile ms-Grid" dir="ltr">
                        <div className={"ms-Grid-row flex-center"}>
                            <div className="ms-Grid-col margin-left-auto">
                                <DefaultButton onClick={() => {
                                    routerHistory.push("/changepassword");
                                }}>{t("ChangePassword")}</DefaultButton>
                            </div>
                        </div>
                        <div>
                            <div className={"ms-Grid-row flex-center"}>
                                <div className="ms-Grid-col margin-auto">
                                    <Persona
                                        styles={{ details: { display: "none" } }}
                                        imageInitials={commonfn.getNameInitial(detail.FullName)}
                                        size={PersonaSize.size32}
                                        presence={PersonaPresence.none}

                                        initialsColor={PersonaInitialsColor.darkBlue}
                                    />
                                </div>
                            </div>
                            <div className={"ms-Grid-row flex-center"}>
                                <div className="ms-Grid-col margin-auto" style={{ textAlign: 'center' }}>
                                    <div> <b>{detail.FullName}</b></div>
                                    <div> {detail.Email}</div>
                                </div>
                            </div>
                            <div className={"ms-Grid-row flex-center"}>
                                <div className="ms-Grid-col ms-md3 margin-auto">
                                    <TextField autoFocus={true} errorMessage={nameErrorMessage} label={t("FullName") + " (*)"} value={detail?.FullName || ""}
                                        onChange={(e, newValue) => { SetDetail({ ...detail, FullName: newValue }); SetNameErrorMessage(""); }}></TextField>
                                </div>
                            </div>
                            <div className={"ms-Grid-row flex-center"}>
                                <div className="ms-Grid-col  ms-md3 margin-auto">
                                    <TextField autoFocus={true} disabled label={t("Email")} value={detail?.Email || ""}
                                    ></TextField>
                                </div>
                            </div>
                            <div className={"ms-Grid-row flex-center"}>
                                <div className="ms-Grid-col ms-md3 margin-auto">
                                    <TextField autoFocus={false} label={t("TelephoneNumber")} value={detail?.PhoneNumber || ""}
                                        onChange={(e, newValue) => { SetDetail({ ...detail, PhoneNumber: newValue }); }}
                                    ></TextField>
                                </div>
                            </div>
                            {/* <div className={"ms-Grid-row flex-center"}>
                                <div className="ms-Grid-col ms-md3  margin-auto">
                                    <Dropdown options={listLanguage} label={t("Language")} selectedKey="en" onChange={(ev, option) => {
                                    }}></Dropdown>
                                </div>
                            </div> */}
                        </div>
                        <div className={"ms-Grid-row flex-center"}>
                            <div className="ms-Grid-col ms-md3 margin-auto">
                                <div style={{ textAlign: 'right' }}>
                                    <PrimaryButton onClick={() => { save() }}>{t("Save")}</PrimaryButton>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    );
}
export default UserProfile;


